import { Box } from '@material-ui/core';
import { createElement } from 'react';

interface SwipeablePanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function SwipeablePanel(props: SwipeablePanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default SwipeablePanel;
